<script lang="ts">
	import { onMount, tick } from "svelte";

	onMount(async () => {
		const urlParams = new URLSearchParams(window.location.search);
		const scrollTo = urlParams.get("scrollTo");

		await tick();
		try {
			setTimeout(() => {
				if (scrollTo === null) return;
				const el = document.getElementById(scrollTo);
				if (el) {
					setTimeout(() => {
						el.scrollIntoView({
							block: "start"
						});
					}, 50);
				}
			}, 50);
		} catch (err) {}
	});
</script>
